// Merchant Service - GraphQL operations for Merchant role
import { graphqlClient } from '../graphqlClient';

// ==================== Profile ====================

export const getProfile = async () => {
  const query = `
    query GetMerchantProfile {
      merchantProfile {
        id
        email
        name
        status
        code
        depositCommission
        withdrawalCommission
        percentageFee
        parentName
        parentType
        parentDepositCommission
        parentWithdrawalCommission
        parentPercentageFee
        createdAt
        updatedAt
      }
    }
  `;
  
  const result = await graphqlClient.query(query);
  return result.merchantProfile;
};

export const updateProfile = async (input) => {
  const mutation = `
    mutation MerchantUpdateProfile($input: MerchantUpdateProfileInput!) {
      merchantUpdateProfile(input: $input) {
        id
        email
        name
        status
        createdAt
        updatedAt
      }
    }
  `;
  
  const result = await graphqlClient.mutate(mutation, { input });
  return result.merchantUpdateProfile;
};

// ==================== Dashboard Stats ====================

export const getDashboardStats = async () => {
  const query = `
    query GetMerchantDashboardStats {
      merchantDashboardStats {
        totalTransactions
        totalDeposits
        totalWithdrawals
        successfulTransactions
        failedTransactions
      }
    }
  `;
  
  const result = await graphqlClient.query(query);
  return result.merchantDashboardStats;
};





